export default "__VITE_ASSET__Cv2v4bH9__"